import React from "react";
import { LockIcon } from "../../../../utils/icons";
import { connect } from "react-redux";
import { CancelOutlined, LockOpenOutlined } from "@material-ui/icons";
import { getEndIcon } from "../../../../utils/utils";
import {
  setPlayerLFDCount,
  setDisplayPlayers,
  setPlayerCounts,
  updateDisplayPlayers,
} from "../../../../redux/GameInformation/GameInformationAction";
import "../PlayerInformation/PlayerInformation.css";
import { getID } from "../../../../firebase";
import {
  addDataToExcludedCollection,
  addDataToLockedCollection,
  resetPlayerForSlate,
} from "../../../../firestoreQueries";

function PlayerInformationEnd(props) {
  const [excludedComponent, setExcludedComponent] = React.useState(
    props.player_information_props.deleted
  ); //should come as a props object later which will come from gql
  const [lockedComponent, setLockedComponent] = React.useState(
    props.player_information_props.locked
  ); //should come as a props object later which will come from gql
  const [favouritedComponent, setFavouritedComponent] = React.useState(
    props.player_information_props.favourite
  );
  const [endIcon, setEndIcon] = React.useState(
    getEndIcon(lockedComponent, favouritedComponent, excludedComponent)
  );

  const [lfdCountData, setLFDCountData] = React.useState(props.slate_lfd_count);

  React.useEffect(() => {
    setLFDCountData(props.slate_lfd_count);
  }, [
    props.player_information.gameInformationReducer.slate_lfd_count,
    lockedComponent,
    favouritedComponent,
    excludedComponent,
  ]);

  const handleReset = async () => {
    console.log("Reset For Player Clicked");

    const userId = getID();
    const slateId = props.player_information.gameInformationReducer.slate_id;
    const playerID = props.player_id;

    resetPlayerForSlate(userId, playerID, slateId);

    await resetPlayerLFDStatus();

    updateUI();
  };

  const resetPlayerLFDStatus = async () => {
    const currentLFDCount =
      props.player_information.gameInformationReducer.slate_lfd_count;
    const newLFDCounter = {
      locked: -1,
      favourite: 0,
      excluded: 0,
    };

    const toUpdateLFD = {
      locked: currentLFDCount.locked + newLFDCounter.locked,
      favourite: currentLFDCount.favourite + newLFDCounter.favourite,
      excluded: currentLFDCount.excluded + newLFDCounter.excluded,
    };

    setLFDCountData(toUpdateLFD);
    props.update_slate_lfd_count(toUpdateLFD);

    const updateData = {
      operator_player_id: props.player_information_props.OperatorPlayerID,
      locked: false,
      favourite: false,
      excluded: false,
    };
    props.update_player_lfd_flag(updateData);
    return true;
  };

  const updateUI = () => {
    setLockedComponent(false);
    setFavouritedComponent(false);
    setExcludedComponent(false);
    setEndIcon(getEndIcon(false, false, false));
  };

  const getUpdatedDisplayPlayerList = (
    playerId,
    locked,
    favourite,
    excluded
  ) => {
    const currentDisplayPlayerList =
      props.player_information.gameInformationReducer.display_players;
    currentDisplayPlayerList.forEach((displayPlayer) => {
      if (displayPlayer.OperatorPlayerID === playerId) {
        displayPlayer["locked"] = locked;
        displayPlayer["favourite"] = favourite;
        displayPlayer["deleted"] = excluded;
      }
    });
    return currentDisplayPlayerList;
  };

  const createlfdPlayer = async (slate_id, locked, favourite, excluded) => {
    console.log("createLFDPlayer ", lfdCountData);
    const userID = getID();
    const playerId = props.player_information_props.OperatorPlayerID;

    const data = {
      playerID: props.player_information_props.PlayerID,
      slateGameID: slate_id,
      userID: userID,
    };
    if (locked === true) {
      // Firestore add to lockedPlayers
      addDataToLockedCollection(data);
      // update redux lfd count locked +=1
      const updatedDisplayPlayerList = getUpdatedDisplayPlayerList(
        playerId,
        true,
        false,
        false
      );
      console.log("UpdatedDisplayPlayerList", updatedDisplayPlayerList);

      console.log(
        "locked player count create player before update:: ",
        lfdCountData.locked
      );
      const toUpdateCount = {
        ...lfdCountData,
        locked: lfdCountData.locked + 1,
      };
      console.log("To update lfd count: ", toUpdateCount);
      // update redux player list information
      props.update_slate_lfd_count(toUpdateCount);
      setLFDCountData(toUpdateCount);
      setLockedComponent(true);
    } else if (excluded === true) {
      // Firestore add to excludedPlayers
      addDataToExcludedCollection(data);
      // update redux lfd count excluded +=1
      // update playerDetail
      // Find and remove it from the player_detail redux
      const current_player_list =
        props.player_information.gameInformationReducer.display_players;
      const OperatorPlayerID = props.operator_player_id;
      console.log("key operator playerid", OperatorPlayerID);
      const remaining_list = current_player_list.filter(
        (element) => element.OperatorPlayerID !== OperatorPlayerID
      );
      console.log("updating display players");
      props.update_display_players(remaining_list);

      const toUpdateCount = {
        ...lfdCountData,
        excluded: lfdCountData.excluded + 1,
      };
      console.log("To update lfd count: ", toUpdateCount);
      props.update_slate_lfd_count(toUpdateCount);
      const updatedDisplayPlayerList = getUpdatedDisplayPlayerList(
        playerId,
        false,
        false,
        true
      );
      console.log("UpdatedDisplayPlayerList", updatedDisplayPlayerList);
      props.update_display_players(updatedDisplayPlayerList);
      setLFDCountData(toUpdateCount);
      setExcludedComponent(true);
      // Hiding step
      props.setShouldHideComponent(true);
      // Update count
      const count =
        props.player_information.gameInformationReducer.player_counts;
      props.update_player_counts(count - 1);
    }

    // Update the perticular player in display_players state property
    const updateData = {
      operator_player_id: playerId,
      locked,
      favourite,
      excluded,
    };
    props.update_player_lfd_flag(updateData);
    setEndIcon(getEndIcon(locked, favourite, excluded));
  };

  const handleLockFavExcludeClicked = async (
    inputLocked,
    inputFavourite,
    inputExcluded
  ) => {
    console.log(
      "Flags clicked: " + inputLocked + inputFavourite + inputExcluded
    );

    const slate_id = props.player_information.gameInformationReducer.slate_id;

    if (lockedComponent && inputLocked) {
      // do nothing
    } else if (favouritedComponent && inputFavourite) {
      // do nothing
    } else if (excludedComponent && inputExcluded) {
      // do nothing
    } else {
      // do some work
      createlfdPlayer(slate_id, inputLocked, inputFavourite, inputExcluded);
    }
  };

  let pl_res = props.player_information.gameInformationReducer.pl_res;
  return (
    <>
      <div className="align-items-center align-self-center ml-auto mt-3 m-1">
        {pl_res === "C" ? (
          <span class="align-items-center align-self-center">
            <p className=" badge badge-pill badge-primary pl_res">C</p>
          </span>
        ) : pl_res === "VC" ? (
          <span class="align-items-center align-self-center pl_res">
            <p className=" badge badge-pill badge-warning ">V</p>
          </span>
        ) : (
          <span class="align-items-center align-self-center pl_res">
            <p className=" badge badge-pill badge-info ">P</p>
          </span>
        )}
      </div>
      <div className="d-flex align-self-center align-items-center flex-column mr-2">
        <h4 className="text-white font-weight-bold p-2 mt-2 pfp_num">
          {pl_res === "C"
            ? parseFloat(
                props.player_information_props.Dream11ProjectedFantasyPoints * 2
              ).toFixed(1)
            : pl_res === "VC"
            ? parseFloat(
                props.player_information_props.Dream11ProjectedFantasyPoints *
                  1.5
              ).toFixed(1)
            : props.player_information_props.Dream11ProjectedFantasyPoints}
        </h4>
        <b className="text-secondary text-truncate pfp_text">PFP</b>
      </div>

      {props.show_lock_exclude === true ? (
        <div class="btn-group dropleft mr-2">
          <span
            className="text-secondary align-items-center align-self-center dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            style={{ cursor: "pointer" }}
          >
            {endIcon}
          </span>
          <div
            class="bg-dark dropdown-menu m-2 p-1"
            style={{ minHeight: "140px", maxHeight: "140px" }}
          >
            {/* <!-- Dropdown menu links --> */}
            <li
              class="dropdown-item p-2"
              onClick={() => handleLockFavExcludeClicked(true, false, false)}
            >
              <LockIcon className="text-primary lfd_icon"></LockIcon>
              <span className="text-white lfd_text"> Lock</span>
            </li>
            <li
              class="dropdown-item p-2"
              onClick={() => handleLockFavExcludeClicked(false, false, true)}
            >
              <CancelOutlined className="text-danger lfd_icon"></CancelOutlined>
              <span className="text-white  lfd_text"> Exclude</span>
            </li>
            <li
              class="dropdown-item p-2"
              role="button"
              onClick={() => handleReset()}
            >
              <LockOpenOutlined className="text-secondary lfd_icon"></LockOpenOutlined>
              <span className="text-white  lfd_text"> Reset</span>
            </li>
          </div>
        </div>
      ) : null}
      {/* comment end */}
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    player_information: state,
    slate_lfd_count: state.gameInformationReducer.slate_lfd_count,
    slate_lfd_count_locked: state.gameInformationReducer.slate_lfd_count.locked,
    slate_lfd_count_favourite:
      state.gameInformationReducer.slate_lfd_count.favourite,
    slate_lfd_count_excluded:
      state.gameInformationReducer.slate_lfd_count.excluded,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    update_slate_lfd_count: (value) => dispatch(setPlayerLFDCount(value)),
    update_display_players: (value) => dispatch(setDisplayPlayers(value)),
    update_player_counts: (value) => dispatch(setPlayerCounts(value)),
    update_player_lfd_flag: (value) => dispatch(updateDisplayPlayers(value)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerInformationEnd);
